import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FormHandles } from '@unform/core';
import { FiSearch, FiMoreVertical } from 'react-icons/fi';
// import DataTable from 'react-data-table-component';
// import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
	Flex,
} from '@chakra-ui/react';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import { formatPrice } from '../../utils/format';
import Sidebar from '../../components/Sidebar';
import InputDate from '../../components/Inputs/InputDate';
import Loading from '../../components/Loading';
import ModalVenda from '../../components/ComponentsVendas/ModalVenda';
import ModalVendaCancelar from '../../components/ComponentsVendas/ModalVendaCancelar';
import DataTableVendas from '../../components/ComponentsVendas/DataTableVendas';

import {
  Container,
  Content,
  Filtros,
  FormView,
  ListVazio,
  Status,
} from './styles';

type DateData = {
	data_i: string;
	data_f: string;
};
type VendaData = {
  agendamento: boolean;
  campanha: string;
  cupom: { id_desconto: string; type_desc: string; valor: string };
  distance: number;
  duration: number;
  endereco_entrega: EnderecoData;
  formatted_address: string;
  hora_agendada: string;
	cliente: {
		id: string;
		nome: string;
		doc: string;
		phone: string;
		cid: string;
	};
  id_order: number;
  items: ItemData[];
  merchant_id: number;
  mesa: boolean;
  mesa_number: string;
  mesa_token: string;
  order_data: string;
  order_status: string;
	pagamentos: PagamentoData[];
  prev_entrega: string;
  retirar: boolean;
  subTotal: number;
  taxa_entrega: number;
  taxa_service: number;
  tempo_preparo: number;
  tempo_preparo_str: string;
  total: number;
  totalFormatted: string;
  total_merchant: number;
}
type EnderecoData = {
  bai: string;
  cep: string;
  cid: string;
  cidcod: string;
  comp: string;
  distace: {
    distance: { value: number };
    duration: { value: number };
  };
  endereco: string;
  formatted_address: string;
  id: string;
  location: { lat: number; lng: number };
  num: string;
  ponto_ref: string;
  uf: string;
}
type PagamentoData = {
  band_pay: string;
  chave_pay: string;
  currency_pay: string;
  id_pay: number;
  method_pay: string;
  name_pay: string;
  tipchave_pay: string;
  trocoFormatted: string;
  troco_para: number;
  type_pay: string;
  url_pay: string;
}
type ItemData = {
  cod_barras: string;
  complementos: ComplementoData[];
  descricao: string;
  id: string;
  nome: string;
  obs: string;
  promocao: string;
  qtd: number;
  total: number;
  totalFormatted: string;
  url_imagem: string;
  valor: number;
  valorFormatted: string;
}
type ComplementoData = {
  codigo: string;
  descricao: string;
  grupo: string;
  nome: string;
  priceFormatted: string;
  qtd: number;
  qtd_gratis: number;
  qtd_maxima: number;
  valor: number;
}

const Vendas: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { company } = useAuth();

  const [vendaModal, setVendaModal] = useState<VendaData>({} as VendaData);
	const [modalVendaVisible, setModalVendaVisible] = useState(false);
  const [modalVendaCancelarVisible, setModalVendaCancelarVisible] = useState(
    false,
  );

  const [loading, setLoading] = useState(true);
  const [vendas, setVendas] = useState<VendaData[]>([]);

  const columns = [
    {
      name: 'Status',
      selector: 'order_status',
      sortable: true,
      maxWidth: '200px',
      cell: (row: any) => (
        <Status status={row?.order_status && row?.order_status.toUpperCase()}>
          {row?.order_status}
        </Status>
      ),
    },
    {
      name: 'Cliente',
			selector: 'name_cliente',
      sortable: true,
      maxWidth: '350px',
    },
    {
      name: 'Id Pedido',
			selector: 'id_order',
      sortable: false,
      right: true,
      maxWidth: '80px',
    },
    {
      name: 'qtd Itens',
			selector: 'items',
      sortable: false,
      right: true,
      maxWidth: '100px',
      cell: (row: any) => (
        <span style={{ textAlign: 'right' }}>{row?.items.length}</span>
      ),
    },
    {
      name: 'Data Criação',
			selector: 'order_data',
      sortable: true,
      right: true,
      maxWidth: '200px',
    },
    {
      name: 'Vlr Total',
			selector: 'totalFormatted',
      sortable: true,
      right: true,
      maxWidth: '150px',
    },
    {
      name: '',
      selector: '',
      cell: (row: any) => (
        <Menu>
          {({ isOpen }) => (
            <>
              <MenuButton
                className="menu-button"
                as={IconButton}
                isActive={isOpen}
                aria-label="Options"
                icon={<FiMoreVertical />}
                variant="outline"
              />

              <MenuList className="menu-list">
                <MenuItem
                  className="menu-item"
                  onClick={() => {
                    setVendaModal(row);
                    setModalVendaVisible(true);
                  }}
                >
                  Detalhes
                </MenuItem>

                <MenuItem
                  className="menu-item"
                  onClick={() => {
                    setVendaModal(row);
                    setModalVendaCancelarVisible(true);
                  }}
                  isDisabled={
                    row.order_status &&
                    row.order_status.toUpperCase() === 'CANCELADO'
                      ? true
                      : false
                  }
                >
                  Cancelar
                </MenuItem>
              </MenuList>
            </>
          )}
        </Menu>
      ),
      maxWidth: '20px',
    },
  ];
  const tableData = {
    columns,
    data: vendas,
  };

  async function handleFetchVendas(form: DateData) {
		try {
			setLoading(true);
			const { data } = await api.post('portal/vendas/index', { data_i: form.data_i, data_f: form.data_f,});

			console.log('data => ', data);

			if (data.vendas.length > 0) {
				const sales = data.vendas.map((venda: any) => {
					return {
						...venda,
						order_status: venda.order_status ? venda.order_status.toUpperCase() : '-',
						cliente: {
							id: venda.id_cliente ? venda.id_cliente : venda.cliente.id,
							nome: venda.name_cliente ? venda.name_cliente : venda.cliente.nome,
							cid: venda.cliente?.cid,
							doc: venda.cliente?.doc,
							phone: venda.cliente?.phone,
						},
						totalFormatted: formatPrice(venda.total)
					}
				})

				setVendas(sales);
			}

		} catch (error) {
			console.log("ERROR ==> ", error);

		} finally {
			setLoading(false);
		}
  };

  useEffect(() => {
		const fetch = async () => handleFetchVendas({} as DateData);
		fetch();
	}, [company]);

  return (
    <>
      <Container>
        {loading && <Loading />}

        <Sidebar />

        <Content>
          <Filtros>
						<FormView ref={formRef} onSubmit={handleFetchVendas}>
							<Flex width="100%">
								<div className="input-content">
									<span>Data Inicial</span>
									<InputDate
										name="data_i"
										placeholder="Data Inicial"
										containerStyle={{ padding: '5px 7px' }}
									/>
								</div>

								<div className="input-content">
									<span>Data Final</span>
									<InputDate
										name="data_f"
										placeholder="Data Final"
										containerStyle={{ padding: '5px 7px' }}
									/>
								</div>
							</Flex>

							<Flex>
								<div className="input-content input-content-button">
									<span>&nbsp;</span>
									<button type="submit">
										<FiSearch /> Pesquisar
									</button>
								</div>
							</Flex>
            </FormView>
          </Filtros>

					{vendas.length > 0 ? (
						<DataTableVendas
							data={vendas}
							setVendaModal={setVendaModal}
							setModalVendaVisible={setModalVendaVisible}
							setModalVendaCancelarVisible={setModalVendaCancelarVisible}
						/>
					) : (
						<ListVazio>
							<h3>Nenhum venda neste período.</h3>
						</ListVazio>
					)}
        </Content>
      </Container>

      {modalVendaVisible && (
        <ModalVenda
          onClose={() => setModalVendaVisible(false)}
          isVisible={modalVendaVisible}
          venda={vendaModal}
        />
      )}

      {modalVendaCancelarVisible && (
        <ModalVendaCancelar
          venda={vendaModal}
          onClose={() => setModalVendaCancelarVisible(false)}
        />
      )}
    </>
  );
};

export default Vendas;
